import React, { useContext, useState } from 'react';
import common from "../../common.module.scss";
import { format } from 'date-fns';
import { useNavigate } from "react-router-dom";
import { EmployeeContext } from "../../context/EmployeeContext.jsx";
import useIsMobile from "@/shared/lib/hooks/useIsMobile";
import MobileBlocksSchedule from "../mobileBlockSchedule";
import { deleteSchedule } from "@/pages/adminPanel/api/adminApi.js";
import { toast } from "react-toastify";

// ✅ добавь модалку подтверждения (путь как у тебя в ScheduleTable)
import ConfirmDeleteModal from "../ConfirmDeleteModal.jsx";

export default function DataOfDayTable({ dataOfDay, setDataOfDay }) {
    const { employee } = useContext(EmployeeContext);
    const role = employee?.role;

    const navigate = useNavigate();
    const isMobile = useIsMobile();

    const [toDelete, setToDelete] = useState(null);

    const handleDelete = async () => {
        try {
            await deleteSchedule(toDelete.id);
            setDataOfDay(prev => prev.filter(g => g.id !== toDelete.id));
            toast.success("Запись удалена");
        } catch (e) {
            const errorMessage = e?.response?.data?.message || 'Ошибка удаления';
            toast.error(errorMessage);
            console.error('Ошибка удаления', e);
        } finally {
            setToDelete(null);
        }
    };

    const handleToDelete = (game) => setToDelete(game);

    const showEdit = role !== "MASTER";
    const showDelete = role !== "ADMIN" && role !== "MASTER";

    return (
        <>
            {!isMobile ? (
                <>
                    <table className={`table ${common.table}`}>
                        <thead className={common.tableHeader}>
                        <tr>
                            <th>Время</th>
                            <th>Название</th>
                            <th>Мастер</th>
                            <th>Кол-во Игроков</th>
                            <th>Зал</th>

                            {showEdit && <th></th>}
                            {showDelete && <th></th>}
                        </tr>
                        </thead>

                        <tbody>
                        {dataOfDay.length > 0 ? (
                            dataOfDay.map((day, index) => {
                                const time = format(new Date(day.startedAt), 'HH:mm');

                                return (
                                    <tr key={day.id} className={index % 2 === 1 ? common.altRow : ''}>
                                        <td>{time}</td>
                                        <td>{day.title}</td>
                                        <td>{day.gameMaster}</td>
                                        <td>{day.currentCountPlayers} из {day.maxCountPlayers}</td>
                                        <td>{day.room}</td>

                                        {showEdit && (
                                            <td>
                                              <span
                                                  className={`btn-word black btn-link p-0 ${common.editBtn}`}
                                                  onClick={() => navigate(`/admin/schedule/edit/${day.id}`)}
                                              >
                                                Редактировать
                                              </span>
                                                </td>
                                            )}

                                        {showDelete && (
                                            <td>
                          <span
                              className="btn-word black btn-link text-danger p-0"
                              onClick={() => setToDelete(day)}
                          >
                            Удалить
                          </span>
                                            </td>
                                        )}
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={5 + (showEdit ? 1 : 0) + (showDelete ? 1 : 0)}>
                                    <p className="body text-center mt-4 mb-0">в этот день записей нет</p>
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </>
            ) : (
                dataOfDay.length > 0 ? (
                    <MobileBlocksSchedule games={dataOfDay} setToDelete={handleToDelete} />
                ) : (
                    <p className="body text-center mt-4">в этот день записей нет</p>
                )
            )}

            {toDelete && (
                <ConfirmDeleteModal
                    roomName={toDelete.title}
                    onConfirm={handleDelete}
                    onCancel={() => setToDelete(null)}
                />
            )}
        </>
    );
}
